import { useTranslation } from "react-i18next";
import CircleContainerTruckIcon from "../../../../icons/circleContainerTruckIcon";
import CircleInboxIcon from "../../../../icons/circleInboxIcon";
import CircleUserIcon from "../../../../icons/circleUserIcon";
import LatestUpdates from "./latestUpdates";
import ShipmentChart from "./chart";
import LastUpdatedShipments from "./lastUpdatedShipments";
import { primaryColor } from "../../../../utils";
import CircleFileIcon from "../../../../icons/circleFileIcon";

const AgentHome = () => {
  const { t } = useTranslation();
  return (
    <main className="space-y-5">
      <section className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
        {/* Card 1 */}
        <div className="flex items-start justify-between gap-4 px-6 py-4 bg-white dark:bg-gray-900 rounded-2xl">
          <div>
            <h2 className="text-lg font-medium capitalize dark:text-white">
              {t("activeShipments")}
            </h2>
            <span
              className="block my-4 text-2xl font-medium"
              style={{ color: primaryColor }}
            >
              12
            </span>
            <p className="text-sm capitalize text-mainGray dark:text-gray-400">
              {t("inProgress")}
            </p>
          </div>
          <div>
            <CircleContainerTruckIcon fill={primaryColor} />
          </div>
        </div>

        {/* Card 2 */}
        <div className="flex items-start justify-between gap-4 px-6 py-4 bg-white dark:bg-gray-900 rounded-2xl">
          <div>
            <h2 className="text-lg font-medium capitalize dark:text-white">
              {t("newLadingBills")}
            </h2>
            <span
              className="block my-4 text-2xl font-medium"
              style={{ color: primaryColor }}
            >
              4
            </span>
            <p className="text-sm capitalize text-mainGray dark:text-gray-400">
              {t("issuedToday")}
            </p>
          </div>
          <div>
            <CircleFileIcon fill={primaryColor} />
          </div>
        </div>

        {/* Card 3 */}
        <div className="flex items-start justify-between gap-4 px-6 py-4 bg-white dark:bg-gray-900 rounded-2xl">
          <div>
            <h2 className="text-lg font-medium capitalize dark:text-white">
              {t("newRequests")}
            </h2>
            <span
              className="block my-4 text-2xl font-medium"
              style={{ color: primaryColor }}
            >
              7
            </span>
            <p className="text-sm capitalize text-mainGray dark:text-gray-400">
              {t("waitingForReply")}
            </p>
          </div>
          <div>
            <CircleInboxIcon fill={primaryColor} />
          </div>
        </div>

        {/* Card 4 */}
        <div className="flex items-start justify-between gap-4 px-6 py-4 bg-white dark:bg-gray-900 rounded-2xl">
          <div>
            <h2 className="text-lg font-medium capitalize dark:text-white">
              {t("onlineEmployees")}
            </h2>
            <span
              className="block my-4 text-2xl font-medium"
              style={{ color: primaryColor }}
            >
              5
            </span>
            <p className="text-sm capitalize text-mainGray dark:text-gray-400">
              {t("onlineNow")}
            </p>
          </div>
          <div>
            <CircleUserIcon fill={primaryColor} />
          </div>
        </div>
      </section>

      <div className="flex flex-wrap gap-5 lg:flex-nowrap">
        <div className="w-full lg:flex-1">
          <ShipmentChart />
        </div>
        <LatestUpdates />
      </div>

      <LastUpdatedShipments />
    </main>
  );
};

export default AgentHome;
